/**
 * @generated SignedSource<<8001fc8c6d0ee3d57cc801dfc8a49908>>
 * @relayHash 79093d95234bb37c9805ad40ab86c1d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6cc83458dddd26949a1d2c41df7db3c9d1a965af96dc7e25b67c5090f7e5216

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type emailInviterNotificationMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type emailInviterNotificationMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type emailInviterNotificationMutation = {
  response: emailInviterNotificationMutation$data;
  variables: emailInviterNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "channel",
                "value": "EMAIL"
              },
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "PROJECT_INVITER_NOTIFICATION"
              }
            ],
            "kind": "ObjectValue",
            "name": "preferences.0"
          }
        ],
        "kind": "ListValue",
        "name": "preferences"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "emailInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emailInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "projectInviterNotification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "JiraNotificationChannel",
                        "kind": "LinkedField",
                        "name": "emailChannel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b6cc83458dddd26949a1d2c41df7db3c9d1a965af96dc7e25b67c5090f7e5216",
    "metadata": {},
    "name": "emailInviterNotificationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4fbb51707da54cc36a75a94c102438ef";

export default node;
